import api from './api';

const usuarioService = {
  // Obtener roles
  getRoles: async () => {
  return await api.get('/roles');
  },
  // Obtener todos los usuarios
getUsuarios: async (search = '') => {
  try {
    return await api.get(`/usuarios?search=${search}`); // Quitar el prefijo /api/
  } catch (error) {
    if (error.response && error.response.status === 403) {
      console.warn('No tienes permisos para ver la lista completa de usuarios');
      return { data: [] };
    }
    throw error;
  }
},

  // Obtener usuarios disponibles (para asignar a especialistas)
  getUsuariosDisponibles: async () => {
    return await api.get('/usuarios/disponibles');
  },

  // Obtener usuario por ID
  getUsuario: async (id) => {
    return await api.get(`/usuarios/${id}`);
  },

  // Crear usuario
  createUsuario: async (data) => {
    return await api.post('/usuarios', data);
  },

  // Actualizar usuario
  updateUsuario: async (id, data) => {
    return await api.put(`/usuarios/${id}`, data);
  },

  // Actualizar contraseña
  updatePassword: async (id, data) => {
    return await api.put(`/usuarios/${id}/password`, data);
  },

  // Eliminar usuario (marcar como inactivo)
  deleteUsuario: async (id) => {
    return await api.delete(`/usuarios/${id}`);
  }
  
};

export default usuarioService;